import dayjs from "dayjs";
import {
  CALENDAR_RESERVATION_TYPE,
  DATE_FORMAT,
  LaunchDateMBStudio,
  LaunchDateMeetingRooms,
  LaunchDateRetreat,
  LaunchDateWorkspace,
  MEMBER_BENEFITS_TYPE,
} from "./constants";
import clubIcon from "../assets/images/dfw-icons/dfw-Club.svg";
import creatorsIcon from "../assets/images/dfw-icons/dfw-Creators.svg";
import dreamersIcon from "../assets/images/dfw-icons/dfw-Dreamers.svg";
import explorerIcon from "../assets/images/dfw-icons/dfw-Explorer.svg";
import freeIcon from "../assets/images/dfw-icons/dfw-Free.svg";
import innovatorsIcon from "../assets/images/dfw-icons/dfw-Innovators.svg";
import mavericksIcon from "../assets/images/dfw-icons/dfw-Mavericks.svg";
import optimistsIcon from "../assets/images/dfw-icons/dfw-Optimists.svg";
import ruleBreakersIcon from "../assets/images/dfw-icons/dfw-Rule-breakers.svg";
import teamIcon from "../assets/images/dfw-icons/dfw-Team.svg";
import thinkersIcon from "../assets/images/dfw-icons/dfw-Thinkers.svg";
import visionariesIcon from "../assets/images/dfw-icons/dfw-Visionaries.svg";
import welnessAreaIcon from "../assets/images/dfw-icons/dfw-Welness-Area.svg";
import dfRealLifeImage1 from "../assets/images/real-life-images/df-workspace-real-image-1.png";
import dfRealLifeImage2 from "../assets/images/real-life-images/df-workspace-real-image-2.png";
import dfRealLifeImage3 from "../assets/images/real-life-images/df-workspace-real-image-3.png";
import dfRealLifeImage4 from "../assets/images/real-life-images/df-workspace-real-image-4.png";
import eventRealLifeImage1 from "../assets/images/real-life-images/event-real-image-1.png";
import eventRealLifeImage2 from "../assets/images/real-life-images/event-real-image-2.png";
import eventRealLifeImage3 from "../assets/images/real-life-images/event-real-image-3.png";
import eventRealLifeImage4 from "../assets/images/real-life-images/event-real-image-4.png";
import eventRealLifeImage5 from "../assets/images/real-life-images/event-real-image-5.png";
import eventRealLifeImage6 from "../assets/images/real-life-images/event-real-image-6.png";
import eventRealLifeImage7 from "../assets/images/real-life-images/event-real-image-7.png";
import eventRealLifeImage8 from "../assets/images/real-life-images/event-real-image-8.png";
import eventRealLifeImage9 from "../assets/images/real-life-images/event-real-image-9.png";
import mbStudioRealLifeImage1 from "../assets/images/real-life-images/mb-studio-real-image-1.png";
import mbStudioRealLifeImage2 from "../assets/images/real-life-images/mb-studio-real-image-2.png";
import mbStudioRealLifeImage3 from "../assets/images/real-life-images/mb-studio-real-image-3.png";
import mbStudioRealLifeImage4 from "../assets/images/real-life-images/mb-studio-real-image-4.png";
import workshopRealLifeImage1 from "../assets/images/real-life-images/workshop-real-image-1.png";
import workshopRealLifeImage2 from "../assets/images/real-life-images/workshop-real-image-2.png";
import innovativeSpaceRealLifeImage1 from "../assets/images/real-life-images/innovative-space-image-1.png";
import innovativeSpaceRealLifeImage2 from "../assets/images/real-life-images/innovative-space-image-2.png";
import innovativeSpaceRealLifeImage3 from "../assets/images/real-life-images/innovative-space-image-3.png";
import innovativeSpaceRealLifeImage4 from "../assets/images/real-life-images/innovative-space-image-4.png";
import creativeSpaceRealLifeImage1 from "../assets/images/real-life-images/creative-space-image-1.png";
import creativeSpaceRealLifeImage2 from "../assets/images/real-life-images/creative-space-image-2.png";
import creativeSpaceRealLifeImage3 from "../assets/images/real-life-images/creative-space-image-3.png";
import creativeSpaceRealLifeImage4 from "../assets/images/real-life-images/creative-space-image-4.png";
import communicateSpaceRealLifeImage1 from "../assets/images/real-life-images/communicate-space-image-1.png";
import communicateSpaceRealLifeImage2 from "../assets/images/real-life-images/communicate-space-image-2.png";
import greynCard from "../assets/images/membership-greyn-card.svg";
import chromeCard from "../assets/images/membership-chrome-card.svg";
import supremeCard from "../assets/images/membership-supreme-card.svg";
import nomadCard from "../assets/images/membership-nomad-card.png";
import mavenCard from "../assets/images/membership-maven-card.png";
import executiveCard from "../assets/images/membership-executive-card.png";

interface RefundRuleDisplay {
  title: string;
  subTitle: string;
}
interface RefundTier {
  days: number;
  percent: number;
  title: string;
}

export const formatDateString = (dateString: string) => {
  return dateString ? dayjs(dateString).format(DATE_FORMAT) : "---";
};

export const formatedCurrentDate = () => {
  const now = new Date();
  const monthName = now.toLocaleString("en-US", { month: "long" }); // October
  const year = now.getFullYear();
  return `${monthName}, ${year}`;
};

export const formatEnumValue = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const safeParse = (data: string | null): any | null => {
  if (!data || data === "null" || data === "undefined") return null;
  try {
    return JSON.parse(data);
  } catch {
    return null;
  }
};

export const getIsActiveMemberStatus = (data: any) => {
  const isMembershipActive =
    data?.credit?.membership_end_date &&
    new Date(data.credit.membership_end_date) > new Date();
  return isMembershipActive;
};

export const getWorkspaceSlotTime = (startTime: string): string => {
  const date = new Date(startTime);
  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const isEventStarted = (startDateTime: string): boolean => {
  return new Date() >= new Date(startDateTime);
};

export function getWorkspaceSlotDuration(
  startTime: string,
  endTime: string,
): string {
  const start = new Date(startTime);
  const end = new Date(endTime);
  const diffMs = end.getTime() - start.getTime();
  const diffMinutes = Math.floor(diffMs / (1000 * 60));

  if (diffMinutes >= 60) {
    const hours = Math.floor(diffMinutes / 60);
    const minutes = diffMinutes % 60;
    return minutes > 0
      ? `${hours} hour${hours > 1 ? "s" : ""} ${minutes} minute${
          minutes > 1 ? "s" : ""
        }`
      : `${hours} hour${hours > 1 ? "s" : ""}`;
  } else {
    return `${diffMinutes} minute${diffMinutes !== 1 ? "s" : ""}`;
  }
}

export function formatRetreatTime(timeISO: string): string {
  const start = new Date(timeISO);
  const formatHourMin = (date: Date) =>
    date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  return formatHourMin(start);
}

export function formatWorkspaceTimeRange(
  startISO: string,
  endISO: string,
): string {
  const start = new Date(startISO);
  const end = new Date(endISO);
  const weekday = start.toLocaleDateString("en-US", { weekday: "short" });
  const formatHourMin = (date: Date) =>
    date
      .toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      })
      .replace(/ (AM|PM)/, "");
  const endAmPm =
    end
      .toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      })
      .match(/AM|PM/i)?.[0] || "";
  return `${weekday}, ${formatHourMin(start)} - ${formatHourMin(
    end,
  )} ${endAmPm}`;
}

export function formatExperiencePassTimeRange(startISO: string) {
  const start = new Date(startISO);
  const weekday = start.toLocaleDateString("en-US", {
    weekday: "short",
  });
  const day = start.getDate();
  const getOrdinalSuffix = (day: any) => {
    if (day >= 11 && day <= 13) return "th";

    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const month = start.toLocaleDateString("en-US", {
    month: "short",
  });

  const time = start
    .toLocaleTimeString("en-US", {
      hour: "numeric",
      hour12: true,
    })
    .replace(" AM", " AM")
    .replace(" PM", " PM");

  return `${weekday}, ${day}${getOrdinalSuffix(day)} ${month} @ ${time}`;
}

export function isPaidSlot(type: string): boolean {
  return type !== CALENDAR_RESERVATION_TYPE.MEETING_ROOMS;
}

export function separateLastWord(text: string): {
  mainString: string;
  lastWord: string | null;
} {
  text = text.trim();
  const lastSpaceIndex = text.lastIndexOf(" ");

  if (lastSpaceIndex === -1) {
    return { mainString: "", lastWord: text };
  }

  const mainString = text.substring(0, lastSpaceIndex);
  const lastWord = text.substring(lastSpaceIndex + 1);

  return { mainString, lastWord };
}
export interface MembershipPlanType {
  title: string;
  subTitle: string;
  creditType?: string;
}

export const membershipPlanTypes: MembershipPlanType[] = [
  {
    title: "ACCESS TO",
    subTitle: "EXECUTION SPACE",
    creditType: "dfw_credits",
  },
  {
    title: "INVITES TO",
    subTitle: "CURATED EXPERIENCES",
    creditType: "event_credits",
  },
  {
    title: "INVITES TO",
    subTitle: "RETREAT",
  },
  {
    title: "INVITES TO",
    subTitle: "SMART SCALING WORKSHOPS",
    creditType: "workshop_credits",
  },
  {
    title: "ACCESS TO",
    subTitle: "WELLNESS SPACE",
    creditType: "mbs_credits",
  },
  {
    title: "Access to",
    subTitle: "ENERGY SPACE",
  },
  {
    title: "FOUNDER",
    subTitle: "COMMUNITY",
  },
  {
    title: "DIGITAL RESOURCES &",
    subTitle: "TEMPLATES",
  },
];

export const executionMembershipPlanTypes: MembershipPlanType[] = [
  {
    title: "ACCESS TO",
    subTitle: "EXECUTION SPACE",
    creditType: "dfw_credits",
  },
  {
    title: "Access to",
    subTitle: "ENERGY SPACE",
  },
];

const toMinutes = (startTime: string): number => {
  const time = getWorkspaceSlotTime(startTime);
  const [hhmm, period] = time.split(" ");
  let [hour, minute] = hhmm.split(":").map(Number);
  if (period === "PM" && hour < 12) hour += 12;
  if (period === "AM" && hour === 12) hour = 0;
  return hour * 60 + minute;
};

export const getDFWIcons = (time: string) => {
  const mins = toMinutes(time);

  if (mins >= 8 * 60 && mins < 9 * 60) return welnessAreaIcon;
  if (mins >= 9 * 60 && mins < 10 * 60) return freeIcon;
  if (mins >= 10 * 60 && mins < 11 * 60) return visionariesIcon;
  if (mins >= 11 * 60 && mins < 12 * 60) return thinkersIcon;
  if (mins >= 12 * 60 && mins < 13 * 60) return innovatorsIcon;
  if (mins >= 13 * 60 && mins < 14 * 60) return dreamersIcon;
  if (mins >= 14 * 60 && mins < 15 * 60) return optimistsIcon;
  if (mins >= 15 * 60 && mins < 16 * 60) return teamIcon;
  if (mins >= 16 * 60 && mins < 17 * 60) return creatorsIcon;
  if (mins >= 17 * 60 && mins < 18 * 60) return mavericksIcon;
  if (mins >= 18 * 60 && mins < 19 * 60) return explorerIcon;
  if (mins >= 19 * 60 && mins < 20 * 60) return ruleBreakersIcon;
  return clubIcon;
};

export const getMembershipPassesIcon = (index: number) => {
  const iconArray = [
    welnessAreaIcon,
    freeIcon,
    visionariesIcon,
    thinkersIcon,
    innovatorsIcon,
    dreamersIcon,
    optimistsIcon,
    teamIcon,
    creatorsIcon,
    mavericksIcon,
    explorerIcon,
    ruleBreakersIcon,
  ];
  return iconArray[index % iconArray.length];
};

export const highlightLastWord = (text: string, highlightCount: number = 1) => {
  const words = text.trim().split(/\s+/);

  if (words.length === 0) return null;

  // If highlight count is greater than or equal to total words,
  // highlight the entire text
  const normalWords = words.slice(0, -highlightCount);
  const highlightedWords = words.slice(-highlightCount);

  return (
    <>
      {normalWords.length > 0 && `${normalWords.join(" ")} `}
      <span style={{ color: "#FF6B35" }}>{highlightedWords.join(" ")}</span>
    </>
  );
};

// export const getDFWIcons = (time: string) => {
//   const storedIconKey = "dfwRandomIcon";
//   let selectedIcon = sessionStorage.getItem(storedIconKey);
//   if (!selectedIcon) {
//     const dfwIcons = [
//       welnessAreaIcon,
//       freeIcon,
//       visionariesIcon,
//       thinkersIcon,
//       innovatorsIcon,
//       dreamersIcon,
//       optimistsIcon,
//       teamIcon,
//       creatorsIcon,
//       mavericksIcon,
//       explorerIcon,
//       ruleBreakersIcon,
//       clubIcon,
//     ];
//     const randomIndex = Math.floor(Math.random() * dfwIcons.length);
//     selectedIcon = dfwIcons[randomIndex];
//     sessionStorage.setItem(storedIconKey, selectedIcon as string);
//   }
//   return selectedIcon;
// };

export const getCalendarRealLifeImages = (type: string) => {
  if (type === CALENDAR_RESERVATION_TYPE.DF_WORKSPACE) {
    return [
      dfRealLifeImage1,
      dfRealLifeImage2,
      dfRealLifeImage3,
      dfRealLifeImage4,
    ];
  } else if (type === CALENDAR_RESERVATION_TYPE.MB_STUDIO) {
    return [
      mbStudioRealLifeImage1,
      mbStudioRealLifeImage2,
      mbStudioRealLifeImage3,
      mbStudioRealLifeImage4,
    ];
  } else if (type === CALENDAR_RESERVATION_TYPE.EVENTS) {
    return [
      eventRealLifeImage1,
      eventRealLifeImage2,
      eventRealLifeImage3,
      eventRealLifeImage4,
      eventRealLifeImage5,
      eventRealLifeImage6,
    ];
  } else if (type === CALENDAR_RESERVATION_TYPE.WORKSHOP) {
    return [workshopRealLifeImage1, workshopRealLifeImage2];
  } else if (type === CALENDAR_RESERVATION_TYPE.MEETING_ROOMS) {
    return [
      dfRealLifeImage1,
      dfRealLifeImage2,
      dfRealLifeImage3,
      dfRealLifeImage4,
    ];
  } else if (type === CALENDAR_RESERVATION_TYPE.RETREAT) {
    return [
      eventRealLifeImage1,
      eventRealLifeImage2,
      eventRealLifeImage3,
      eventRealLifeImage4,
      eventRealLifeImage5,
      eventRealLifeImage6,
    ];
  } else {
    return [];
  }
};

export const getMemberBenefitsRealLifeImages = (type: string) => {
  if (type === MEMBER_BENEFITS_TYPE.INNOVATIVE_SPACE) {
    return [
      innovativeSpaceRealLifeImage1,
      innovativeSpaceRealLifeImage2,
      innovativeSpaceRealLifeImage3,
      innovativeSpaceRealLifeImage4,
    ];
  } else if (type === MEMBER_BENEFITS_TYPE.CREATIVE_SPACE) {
    return [
      creativeSpaceRealLifeImage1,
      creativeSpaceRealLifeImage2,
      creativeSpaceRealLifeImage3,
      creativeSpaceRealLifeImage4,
    ];
  } else if (type === MEMBER_BENEFITS_TYPE.EVENTS) {
    return [eventRealLifeImage7, eventRealLifeImage8, eventRealLifeImage9];
  } else if (type === MEMBER_BENEFITS_TYPE.RETREAT) {
    return [workshopRealLifeImage1, workshopRealLifeImage2];
  } else if (type === MEMBER_BENEFITS_TYPE.COMMUNICATE_SPACE) {
    return [communicateSpaceRealLifeImage1, communicateSpaceRealLifeImage2];
  } else if (type === MEMBER_BENEFITS_TYPE.MB_STUDIO) {
    return [
      mbStudioRealLifeImage1,
      mbStudioRealLifeImage2,
      mbStudioRealLifeImage3,
      mbStudioRealLifeImage4,
    ];
  } else {
    return [];
  }
};

const REFUND_POLICIES: Record<string, RefundTier[]> = {
  [CALENDAR_RESERVATION_TYPE.DF_WORKSPACE]: [
    { days: 0, percent: 100, title: "Anytime before event" },
  ],
  [CALENDAR_RESERVATION_TYPE.EVENTS]: [
    { days: 7, percent: 100, title: "7+ days before event" },
    { days: 2, percent: 50, title: "2+ days before event" },
    { days: 0, percent: 0, title: "Under 2 days" },
  ],
  [CALENDAR_RESERVATION_TYPE.WORKSHOP]: [
    { days: 7, percent: 100, title: "7+ days before event" },
    { days: 2, percent: 50, title: "2+ days before event" },
    { days: 0, percent: 0, title: "Under 2 days" },
  ],
  [CALENDAR_RESERVATION_TYPE.RETREAT]: [
    { days: 30, percent: 100, title: "30+ days before event" },
    { days: 15, percent: 50, title: "15+ days before event" },
    { days: 0, percent: 0, title: "Under 15 days" },
  ],
  [CALENDAR_RESERVATION_TYPE.MEETING_ROOMS]: [
    { days: 2, percent: 100, title: "2+ days before event" },
    { days: 1, percent: 50, title: "1+ days before event" },
    { days: 0, percent: 25, title: "Under 1 day" },
  ],
  [CALENDAR_RESERVATION_TYPE.MB_STUDIO]: [
    { days: 8, percent: 100, title: "7+ days before event" },
    { days: 3, percent: 50, title: "Under 7 days" },
    { days: 0, percent: 0, title: "Under 3 days" },
  ],
};

export const getCreditRefundDetail = (
  serviceType: string,
): RefundRuleDisplay[] => {
  const rules = REFUND_POLICIES[serviceType];

  if (!rules || rules.length === 0) {
    return [{ title: "Refund policy not available", subTitle: "" }];
  }

  return rules.map((rule) => ({
    title: rule.title,
    subTitle: `${rule.percent}% ${rule.percent === 0 ? "Refund" : "Refund in Credit Wallet"}`,
  }));
};

export const checkNonMemberCredits = (
  creditData: any,
  slotData: any,
): boolean => {
  const serviceType = slotData?.service_type;
  const creditRequired = slotData?.credits_required;
  if (
    serviceType === CALENDAR_RESERVATION_TYPE.DF_WORKSPACE ||
    serviceType === CALENDAR_RESERVATION_TYPE.MEETING_ROOMS ||
    serviceType === CALENDAR_RESERVATION_TYPE.INNOVATE_SPACE
  ) {
    return creditData?.dfw_credits >= creditRequired;
  } else if (serviceType === CALENDAR_RESERVATION_TYPE.MB_STUDIO) {
    return creditData?.mbs_credits >= creditRequired;
  } else if (
    serviceType === CALENDAR_RESERVATION_TYPE.EVENTS ||
    serviceType === CALENDAR_RESERVATION_TYPE.RETREAT
  ) {
    return creditData?.event_credits >= creditRequired;
  } else if (serviceType === CALENDAR_RESERVATION_TYPE.WORKSHOP) {
    return creditData?.workshop_credits >= creditRequired;
  } else {
    return false;
  }
};

export const getLaunchDateStatus = (date: Date, type: string) => {
  switch (type) {
    case CALENDAR_RESERVATION_TYPE.DF_WORKSPACE:
      return date > LaunchDateWorkspace;

    case CALENDAR_RESERVATION_TYPE.MB_STUDIO:
      return date > LaunchDateMBStudio;

    case CALENDAR_RESERVATION_TYPE.EVENTS:
      return true;

    case CALENDAR_RESERVATION_TYPE.WORKSHOP:
      return date > LaunchDateWorkspace;

    case CALENDAR_RESERVATION_TYPE.RETREAT:
      return date > LaunchDateRetreat;

    case CALENDAR_RESERVATION_TYPE.MEETING_ROOMS:
      return date > LaunchDateMeetingRooms;

    default:
      return true;
  }
};

export const getMembershipCardImage = (type: string) => {
  switch (type) {
    case "GREYN":
      return greynCard;

    case "SUPREME":
      return supremeCard;

    case "NOMAD":
      return nomadCard;

    case "MAVEN":
      return mavenCard;

    case "EXECUTIVE":
      return executiveCard;

    default:
      return chromeCard;
  }
};

export const getFirstAndRemainingWords = (text: string = "") => {
  const words = text.trim().split(/\s+/).filter(Boolean);

  return {
    firstWord: words[0] ?? "",
    remainingWords: words.slice(1).join(" "),
  };
};

export const getCancellationpolicy = (type: string) => {
  if (
    type === CALENDAR_RESERVATION_TYPE.EVENTS ||
    type === CALENDAR_RESERVATION_TYPE.WORKSHOP
  ) {
    return (
      <div>
        <ul>
          <li>7+ days before event: → 100% Refund in Credit Wallet</li>
          <li>Under 7 days: → 50% Refund in Credit Wallet</li>
          <li>Under 48 hours: → 0% Refund</li>
        </ul>
        <strong style={{ color: "#FF6B35" }}>ADDITIONAL TERMS</strong>
        <br />
        <ul>
          <li>
            Cancelled by the Company due to unseen circumstances → 100% Refund +
            priority seat for next event
          </li>
        </ul>
      </div>
    );
  } else if (
    type === CALENDAR_RESERVATION_TYPE.DF_WORKSPACE ||
    type === CALENDAR_RESERVATION_TYPE.MEETING_ROOMS
  ) {
    return (
      <ul>
        <li>2+ hours before start time: → 100% Refund in Credit Wallet</li>
        <li>Under 2 hours: → 80% Refund in Credit Wallet</li>
        <li>No-Show: → 0% Refund</li>
      </ul>
    );
  } else if (type === CALENDAR_RESERVATION_TYPE.MB_STUDIO) {
    return (
      <div>
        <ul>
          <li>7+ days before session: → 100% Refund in Credit Wallet</li>
          <li>Under 7 days:→ 50% Refund in Credit Wallet</li>
          <li>Under 48 hours or No-Show: → 0% Refund</li>
        </ul>
        <strong style={{ color: "#FF6B35" }}>ADDITIONAL TERMS</strong>
        <br />
        <ul>
          <li>High-demand classes may be non-cancellable within 72 hours</li>
          <li>
            Cancelled by the Company due to unseen circumstances → 100% Refund
          </li>
        </ul>
      </div>
    );
  } else if (type === CALENDAR_RESERVATION_TYPE.RETREAT) {
    return (
      <div>
        <ul>
          <li>14+ days before event: → 100% Refund in Credit Wallet</li>
          <li>Under 14 days: → 50% Refund in Credit Wallet</li>
          <li>Under 7 days: → 0% Refund</li>
        </ul>
        <strong style={{ color: "#FF6B35" }}>ADDITIONAL TERMS</strong>
        <br />
        <ul>
          <li>
            Cancelled by the Company due to unseen circumstances → 100% Refund
          </li>
        </ul>
      </div>
    );
  }
};

export const getTermaAndConditionsText = (type: string) => {
  return (
    <div>
      <strong style={{ color: "#FF6B35" }}>GENERAL TERMS</strong>
      <br />
      <ul>
        <li>Please arrive on time for your session.</li>
        <li>Respect the purpose of spaces.</li>
        <li>Maintain the intended energy of the room.</li>
      </ul>
      <strong style={{ color: "#FF6B35" }}>BEHAVIORAL CONTRACT</strong>
      <br />
      By booking a session, you agree to:
      <ul>
        <li>Respect the flow and focus of others.</li>
        <li>Keep the space clean and reset your area before leaving.</li>
      </ul>
      You consent to possibly being included (in photos/videos). If you wish to
      opt out, please inform the team at the front desk.
      <br />
      <br />
      <strong style={{ color: "#FF6B35" }}>MEDIA PERMISSION</strong>
      <br />
      At times, The Foundry may capture ambient photos/videos within the space
      for community highlights. By entering, you consent to possibly being
      included. (If you wish to opt out, please inform the team at the front
      desk.)
      <br />
      <br />
      <strong style={{ color: "#FF6B35" }}>CANCELLATION POLICY</strong>
      <br />
      {getCancellationpolicy(type)}
    </div>
  );
};

export function getEventOfferColor(index: number): string {
  const offerColors = ["#C1F700", "#9B5DE5", "#FF6B35"];
  return offerColors[index % offerColors.length];
}

export function getDiscountPercentage(
  price: number,
  discountedPrice: number,
): number {
  if (price <= 0) {
    return 0;
  }
  return Math.round(((price - discountedPrice) / price) * 100);
}

export function calculateGSTPrice(price: number, gst: number): number {
  return Math.floor((price * gst) / 100);
}
